import Bloomreach from '@mediashop/catalog-base/bloomreach';
import MainNavigationVerticalBrand from './MainNavigationVerticalBrand';

export default {
    ...Bloomreach,
    MainNavigationVerticalBrand,
};
